import React from 'react';
import type { IDeveloperCardProps } from './solution-developer-card';
import { DeveloperCard, dtoToDevCardProps } from './solution-developer-card';
import { PreviewMode } from '../../preview-elements/preview-context';
import type { ITagsBoxProps } from './solution-tag-box';
import { dtoToTagsBoxProps, TagsBox } from './solution-tag-box';
import s from './solution-overview.scss';
import { composer } from '../../../../component-decorators/composer';
import type { WithTranslation as WithTranslationProps } from 'react-i18next';
import { config } from '../../../../config';
import { Card } from '@wix/design-system';
import type { InjectedExperimentsProps } from '@wix/wix-experiments-react';
import SolutionDescription from './solution-description';
import type { WebSolution } from '@wix/ambassador-marketplace/types';
import { categoryFilter } from '../solution-info';

export interface IOverViewProps
  extends Partial<WithTranslationProps>,
    Partial<InjectedExperimentsProps> {
  description: string;
  appId: string;
  benefits: string[];
  name: string;
  deveoloperCardProps: IDeveloperCardProps;
  solutionDemo?: string;
  tagsBoxProps?: ITagsBoxProps;
  biData?: any;
}

export const dtoToOverViewProps = (
  solutionDto: WebSolution,
): IOverViewProps => {
  return {
    appId: solutionDto.baseInfo.id,
    benefits: solutionDto.webSolutionData.appData.benefits,
    description: solutionDto.baseInfo.description,
    deveoloperCardProps: dtoToDevCardProps(solutionDto),
    tagsBoxProps: dtoToTagsBoxProps(solutionDto),
    name: solutionDto.baseInfo.name,
    solutionDemo: solutionDto.exampleSites && solutionDto.exampleSites[0],
    biData: {
      app_id: solutionDto.baseInfo.id,
      esi: config.esi || '',
      market: config.originForBI,
      category: categoryFilter(solutionDto && solutionDto.baseInfo.Tags),
    },
  };
};

export const SolutionOverView = composer()
  .withTranslation()
  .withMarketplaceStore()
  .withExperiments()
  .compose((props: IOverViewProps) => {
    return (
      <div className={s.solutionOverViewContainer}>
        <SolutionDescription {...props} />
        <div className={s.solutionAppOverviewData}>
          <PreviewMode.Consumer>
            {(value) => {
              return (
                <Card className={s.tagsBox}>
                  <TagsBox {...props.tagsBoxProps} />
                </Card>
              );
            }}
          </PreviewMode.Consumer>
          {props.deveoloperCardProps && (
            <Card>
              <DeveloperCard {...props.deveoloperCardProps} />
            </Card>
          )}
        </div>
      </div>
    );
  });
